export default __webpack_public_path__ + "static/N0052-01a9dad44eb5c64b155d7c6734c41b2f.png";